"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconColdTapWater = function IconColdTapWater(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M39.698 39.7c1.607 1.654 2.468 3.088 2.707 4.348.237 1.252-.157 2.25-.85 2.95l-.142.137c-1.336 1.206-3.42 1.09-4.725.03l-.123-.106c-.664-.593-1.005-1.317-1.077-2.085-.069-.741.116-1.467.395-2.109.552-1.272 1.571-2.446 2.41-3.208l.724-.657zm-.753 2.112c-.491.552-.95 1.192-1.221 1.819-.2.457-.274.85-.245 1.165.027.287.143.558.434.818l.121.098c.623.455 1.53.427 2.023-.017l.107-.107c.237-.262.38-.621.274-1.183-.112-.594-.514-1.447-1.493-2.593M25 4a3 3 0 1 1 0 6h-1v3.834A10.04 10.04 0 0 1 28 17h7a9 9 0 0 1 9 9v10H34v-9h-4.835a10 10 0 0 1-18.33 0H.185a24 24 0 0 1-.163-2h12.23a8.003 8.003 0 0 0 15.496 0H34a2 2 0 0 1 2 2v7h6v-8a7 7 0 0 0-7-7h-8.073A8.01 8.01 0 0 0 22 15.252V10h-4v5.252A8.01 8.01 0 0 0 13.073 19H.523q.216-1.017.515-2H12a10.04 10.04 0 0 1 4-3.166V10h-1l-.153-.004A3 3 0 0 1 15 4zm-4 15.293 1.147-1.147.353.354.353.353L21 20.707V22h1.16l1.45-1.812.782.623-.95 1.189H26L26 24H23.44l.95 1.187L24 25.5l-.39.312L22.16 24H21v1.292l1.854 1.854-.708.707L21 26.706V29h-2v-2.293l-1.147 1.146-.706-.707L19 25.294V24h-1.292l-1.854 1.853-.708-.707L16.294 24H14v-2h2.294l-1.147-1.147.707-.707L17.708 22H19v-1.293l-1.854-1.854.707-.707L19 19.293V17h2zM15 6a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2z"
  })));
};

export { IconColdTapWater, IconColdTapWater as default };
